import index from "./Main"
export default index;